
import { callApi } from "../../services/api.service";
import { fetcSchemeFlows } from "../../services/flows.service";
import { ensureArray, ensureJsonObject } from "../../utils/validateResponseApi";
import { actionTypes } from "../contants/actionTypes"
import { logout } from "./auth";

//#region CHANGES_PENDING_FLOWS
export const changesPendingFlows = (isChangesPending) => ({
    type: actionTypes.floIsChangesPendingFlow,
    payload: isChangesPending
});

export const errorManageFlows = (isError, messageError) => ({
    type: actionTypes.floErrorManageFlows,
    payload: {
        messageError: !messageError ? '' : messageError,
        error: isError
    }
});
//#endregion

export const getSchemes = (accessToken) => {
    return (dispatch) => {
        fetcSchemeFlows(accessToken)
            .then(({ data }) => {
                dispatch(loadSchemesFlows(data));
            }).catch((e) => {
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                } else {
                    dispatch(errorManageFlows(true, 'Ha ocurrido un error cargando la lista de flujos, intentálo de nuevo más tarde'));
                }
            }).finally(() => {
            });
    }
};

export const loadSchemesFlows = (data) => ({
    type: actionTypes.GetSchemes,
    payload: !data ? [] : data
});

export const getDataFlow = (idFlow, accessToken) => {
    return (dispatch) => {
        callApi("flow_select", "SELECT_ID_FLOW", { id_flow: idFlow }, accessToken, { findOne: 'true' })
            .then(({ data }) => {
                dispatch(loadSelectedFlow(ensureJsonObject(data)));
                dispatch(loadData(actionTypes.floChangeFlowInEdition, ensureJsonObject(data)));
            }).catch((e) => {
                console.log('error', e)
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                } else {
                    dispatch(errorManageFlows(true, 'Ha ocurrido un error el detalle del flujo, intentálo de nuevo más tarde'));
                }
            }).finally(() => {
            });
    }
}

export const loadSelectedFlow = (data) => ({
    type: actionTypes.LoadSelectedFlow,
    payload: data
});

export const setNotificaction = (data) => ({
    type: actionTypes.notificaction,
    payload: data
})

export const getFunctionsSchema = (accessToken) => {
    return (dispatch) => {
        callApi("funtions_schema_select", "SELECT", {}, accessToken)
            .then(({ data }) => {
                dispatch(loadData(actionTypes.getFunctionsSchema, ensureArray(data)));
            }).catch((e) => {
                console.log('error', e)
            })
    }
}

export const getListTypesComponent = (accessToken) => {
    return (dispatch) => {
        callApi("component_schema_select", "SELECT_TYPE_COMPONENT", {}, accessToken)
            .then(({ data }) => {
                dispatch(loadData(actionTypes.getListTypesComponent, ensureArray(data)));
            }).catch((e) => {
                console.log('error', e)
            })
    }
}

//////
export const loadData = (action, data) => ({
    type: action,
    payload: data
});
//////
